
import { Vue } from "vue-class-component";
import "./App.scss";

export default class App extends Vue {}
